import { render, staticRenderFns } from "./ComponentTitle.vue?vue&type=template&id=0ac30ede&scoped=true&"
import script from "./ComponentTitle.vue?vue&type=script&lang=js&"
export * from "./ComponentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac30ede",
  null
  
)

export default component.exports